import PropTypes from "prop-types";

export const pricePropType = PropTypes.shape({
  adjusted: PropTypes.number,
  adjustedMaximum: PropTypes.number,
  base: PropTypes.number,
  discounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      value: PropTypes.number,
    })
  ),
  maximum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minimum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maximumFormatted: PropTypes.string,
  minimumFormatted: PropTypes.string,
});
